import { Table, type TableData, Text } from '@mantine/core';
import { useOrganization } from '$/contexts/org.ctx.tsx';
import { useEffect, useState } from 'react';

export default function SeatsTable(){
    const { accessorList } = useOrganization();
    const [data, setData] = useState<TableData>({
        caption: 'Client Results',
        head: ['Name', 'Type', 'Team', 'Comp Ratio', 'Test Counts'],
        body: []
    });

    useEffect(() => {
        if(!accessorList) return;
        const newData = {
            caption: 'Your Users',
            head: ['Name', 'Type', 'Team', 'Comp Ratio', 'Test Counts'],
            body: accessorList.map((accessor) => [accessor.name, accessor.testResult, accessor.team || '-', accessor.compatibilityRatio, accessor.testCounts.join(' / ')])
        }
        setData(newData);
    }, [accessorList]);

    return (
        <Table data={data} stickyHeader stickyHeaderOffset={60} striped highlightOnHover />
    );
}